import { render, staticRenderFns } from "./SetAsApprover.vue?vue&type=template&id=5f885c05&scoped=true"
import script from "./SetAsApprover.vue?vue&type=script&lang=js"
export * from "./SetAsApprover.vue?vue&type=script&lang=js"
import style0 from "./SetAsApprover.vue?vue&type=style&index=0&id=5f885c05&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f885c05",
  null
  
)

export default component.exports